import React, {Component} from "react";
import {Link} from "react-router-dom";
import bigLogo from "../../../assets/images/big-logo.png";
import vk from "../../../assets/images/vk.png";
import mts from "../../../assets/images/mts.png";
import velcom from "../../../assets/images/velcom.png";
import facebook from "../../../assets/images/facebook.png";
import youtube from "../../../assets/images/youtube.png";
import ok from "../../../assets/images/ok.png";

class About extends Component {
	render() {
		return (
			<div className="page">
				<div className="page__title">Букмекерская компания Maxline</div>
				<div className="page__data">
					<div className="about">
						<div className="about__biglogo">
							<Link to={'/'}>
								<img src={bigLogo} alt="Букмекерская компания Maxline"/>
							</Link>
						</div>
						<div className="about__description block">
							<p>Букмекерская компания Maxline открывает перед своими клиентами мир безграничных
								возможностей.
								Любите спорт? Следите за новостями в этой области? Значит, вы можете предположить, какая
								команда или отдельный спортсмен окажется лучше других. Онлайн ставки на спорт помогут
								вашим предположениям превратиться в реальные деньги.
							</p>
							<p>Maxline предлагает большой выбор ставок Live. Здоровый азарт, предвкушение победы и
								радость от выигрыша – вот то, что вы получите, если выберете Букмекерскую компанию
								Maxline. Довольные клиенты – лучшее доказательство нашей репутации. Выбирая нашу
								компанию, вы выбираете надёжность, качество и удобство. Вы можете пополнять игровой счёт
								любым из способов, перечисленных в разделе&nbsp;
								<Link to={'/page/payments'}>"Платежи"</Link>.
							</p>
							<p>Ставки на спорт стали доступнее с развитием технологий. Теперь можно сделать ставку не
								выходя из дома. Просто зайдите на наш сайт, выберите нужную категорию и укажите вашего
								фаворита. Всё предельно просто, ведь Maxline заботится об удобстве.
							</p>
							<p>Онлайн ставки на спорт вместе с Maxline экономят время. Всего за несколько кликов вы
								будете вовлечены в удивительный мир спортивных соревнований, взлётов и падений, надежд и
								разочарований.
							</p>
						</div>
						<div className="about__license block">
							<div className="block__title">Лицензия</div>
							<div className="about__license-data">
								<div className="license-text">
									ООО "Финансово-инвестиционная компания "ИНХО",<br/>
									УНП 191318808,<br/>
									Лицензия №02110/586 от 31.07.2012, выдана Министерством<br/>
									по налогам и сборам Республики Беларусь, Решение №8<br/>
									г. Витебск. проспект строителей д. 10
								</div>
								<div className="license-image">
									<img src="https://maxline.by/assets/images/license.jpg" alt="ООО &quot;Финансово-инвестиционная компания &quot;ИНХО&quot;"/>
								</div>
							</div>
						</div>
						<div className="about__contacts block">
							<div className="block__title">Контакты</div>
							<div className="about__contacts-data">
								<div className="block__subtitle">Круглосуточная служба поддержки</div>
								<div className="about__contacts-contact">
									<img src={mts} className="about__contacts-icon" alt="МТС"/>&nbsp;+375 (29)
									5207777
								</div>
								<div className="about__contacts-contact">
									<img src={velcom} className="about__contacts-icon" alt="Velcom"/>&nbsp;+375 (44)
									5207777
								</div>
								<div className="about__contacts-contact">
									<i className="fab fa-whatsapp about__contacts-icon"></i>&nbsp;WhatsApp
								</div>
								<div className="about__contacts-contact">
									<i className="fab fa-viber about__contacts-icon"></i>&nbsp;Viber
								</div>
								<div className="about__contacts-contact">
									<i className="far fa-envelope about__contacts-icon"></i>&nbsp;support@maxline.by
								</div>
								<div className="about__contacts-contact">
									<i className="far fa-envelope about__contacts-icon"></i>&nbsp;passport@maxline.by
								</div>
								<div className="block__subtitle">Бухгалтерия</div>
								<div className="cl-gray">Для уточнения вопросов, связанных с выплатами, с 8:00 до 17:00
								</div>
								<div className="about__contacts-contact">
									<img src={mts} className="about__contacts-icon" alt="МТС"/>&nbsp;+375 (29) 7525555
								</div>

								<div className="block__subtitle">Маркетинг</div>
								<div className="cl-gray">
									По вопросам рекламы, развития и сотрудничества, с 8:00 до 18:00
								</div>
								<div className="about__contacts-contact">
									<img src={mts} className="about__contacts-icon" alt="МТС"/>&nbsp;+375 (29) 5715555
								</div>
								<div className="about__contacts-contact">
									<i className="fab fa-whatsapp about__contacts-icon"></i>&nbsp;WhatsApp
								</div>
								<div className="about__contacts-contact">
									<i className="fab fa-viber about__contacts-icon"></i>&nbsp;Viber
								</div>
								<div className="about__contacts-contact">
									<i className="far fa-envelope about__contacts-icon"></i>&nbsp;marketing@maxline.by
								</div>

								<div className="block__subtitle">Мы в социальных сетях</div>
								<div className="about__contacts-contact">
									<a href="https://vk.com/maxlineby" target="_blank">
										<img src={vk} alt=""/>
									</a>&nbsp;
									<a href={'https://www.facebook.com/maxlineofficial.by'} target="_blank"><img src={facebook} alt="Facebook"/></a>&nbsp;
									<a href={'https://ok.ru/maxlinesport'} target="_blank"><img src={ok} alt="Odnoklassniki"/></a>&nbsp;
									<a href={'https://www.youtube.com/channel/UC9PLwT3BtDbbZAuExTA5RFQ'} target="_blank"><img src={youtube} alt="Youtube"/></a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default About;


// WEBPACK FOOTER //
// ./src/app/pages/About/About.js